if (!customElements.get('ug-club-earn')) {
  customElements.define('ug-club-earn', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info') || this.closest('.shopify-section');
      if (!this.scope) return;
      try {
        this.variants = JSON.parse(this.querySelector('[data-ug-variants]')?.textContent || '[]');
      } catch {
        this.hidden = true;
        return;
      }
      this.updateBound = () => this.update();
      this.scope.addEventListener('change', this.updateBound);
      this.scope.addEventListener('input', this.updateBound);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const sectionId = this.scope.dataset.originalSection || this.scope.dataset.section;
          if (String(data.sectionId) !== String(sectionId)) return;
          this.currentVariant = data.variant;
          this.update();
        });
        this.quantityUnsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.updateBound);
      }
      this.update();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.updateBound);
      this.scope?.removeEventListener('input', this.updateBound);
      this.variantUnsubscribe?.();
      this.quantityUnsubscribe?.();
    }
    update() {
      const idInput = this.scope.querySelector('form[action*="/cart/add"] input[name="id"]');
      const id = idInput?.value;
      const variant = this.currentVariant && String(this.currentVariant.id) === String(id)
        ? this.currentVariant
        : this.variants.find(item => String(item.id) === String(id));
      if (idInput && (!id || !variant || !variant.available)) {
        this.hidden = true;
        return;
      }
      const price = variant ? variant.price : Number(this.dataset.price);
      const quantity = Math.max(1, Number(this.scope.querySelector('input[name="quantity"]')?.value) || 1);
      if (!Number.isFinite(price) || price < 0) {
        this.hidden = true;
        return;
      }
      const points = Math.round(price * quantity * 0.0006);
      this.hidden = false;
      this.querySelector('[data-ug-earned]').textContent = new Intl.NumberFormat('sr-RS').format(points);
      this.querySelector('[data-ug-value]').textContent = new Intl.NumberFormat('sr-RS', {style:'currency', currency:'RSD'}).format(points * 0.5);
    }
  });
}

/* Reveal the edge tab before letting Glow handle the second click. */
(() => {
  if (window.ugEdgeLauncherReady) return;
  window.ugEdgeLauncherReady = true;
  const isOpen = button => {
    const close = button.querySelector('#closeIcon');
    return close && getComputedStyle(close).display !== 'none';
  };
  const collapse = button => {
    button.classList.remove('ug-launcher-expanded');
    button.setAttribute('aria-label', 'Prikaži UG klub');
  };
  const prepare = () => {
    const button = document.getElementById('loyaltyLauncher');
    if (!button || button.dataset.ugEdgeReady) return;
    button.dataset.ugEdgeReady = 'true';
    collapse(button);
    const close = button.querySelector('#closeIcon');
    if (close) new MutationObserver(() => {
      if (!isOpen(button)) collapse(button);
      else button.setAttribute('aria-label', 'Zatvori UG klub');
    }).observe(close, { attributes: true, attributeFilter: ['style', 'class'] });
  };
  document.addEventListener('click', event => {
    const button = document.getElementById('loyaltyLauncher');
    if (!button) return;
    if (!button.contains(event.target)) {
      if (!isOpen(button)) collapse(button);
      return;
    }
    if (!isOpen(button) && !button.classList.contains('ug-launcher-expanded')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      button.classList.add('ug-launcher-expanded');
      button.setAttribute('aria-label', 'Otvori UG klub');
    }
  }, true);
  document.addEventListener('keydown', event => {
    const button = document.getElementById('loyaltyLauncher');
    if (event.key === 'Escape' && button && !isOpen(button)) collapse(button);
  });
  prepare();
  new MutationObserver(prepare).observe(document.documentElement, { childList: true, subtree: true });
})();
